<template>
  <div>
    <h1 class="text-3xl">Profile</h1>
    <div class="text-left">
      <div>
        <div class="mt-6 grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6">
          <div class="sm:col-span-6">
            <label
              for="nickname"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Nickname
            </label>
            <p class="text-xs text-gray-500">
              This is the name used in emails to your advisors.
            </p>
            <div class="mt-1 flex rounded-md shadow-sm">
              <!-- TODO - ADD SAVE STATUS -->
              <input
                id="nickname"
                v-model="nickname"
                @change="setNickname"
                class="flex-1 form-input block w-full rounded-md transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- TODO - PAYMENTS -->
    <!-- TODO - NOTIFICATIONS -->
    <!-- TODO - DELETE ACCOUNT -->
    <!-- <br />
    <div>
      {{ profile }}
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ProfileView",
  data() {
    return {
      nickname: "",
    };
  },
  computed: mapState({
    profile: (state) => state.profile,
  }),
  methods: {
    setNickname() {
      this.$store.dispatch("profile/setNickname", this.nickname);
    },
  },
  watch: {
    profile: {
      handler() {
        this.nickname = this.profile.nickname;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
